<div class="modal-backdrop" (click)="onCancel()"></div>
<div class="modal">
  <div class="modal-header">
    <h3>{{ 'add_user_dialog.title' | translate }}</h3>
  </div>
  <div class="modal-body">
    <div class="inline-row">
      <label>
        <span>{{ 'add_user_dialog.name' | translate }}</span>
        <input type="text" [(ngModel)]="name" />
      </label>
      <label>
        <span>{{ 'add_user_dialog.last_name' | translate }}</span>
        <input type="text" [(ngModel)]="lastName" />
      </label>
    </div>
    <label>
      <span>{{ 'add_user_dialog.email' | translate }}</span>
      <input type="email" [(ngModel)]="email" />
      <small class="error" *ngIf="email && !emailValid">{{ 'add_user_dialog.invalid_email' | translate }}</small>
    </label>
    <label>
      <span>{{ 'add_user_dialog.business_partner_name' | translate }}</span>
      <app-business-partner-selector [showLevelFilter]="false" (businessPartnerChange)="onBusinessPartnerChange($event)"></app-business-partner-selector>
    </label>
    <label>
      <span>{{ 'add_user_dialog.password' | translate }}</span>
      <div class="password-group">
        <input [type]="showPassword ? 'text' : 'password'" [(ngModel)]="password" />
        <button class="icon-btn" type="button" (click)="showPassword = !showPassword">
          <span class="material-symbols-outlined">{{ showPassword ? 'visibility_off' : 'visibility' }}</span>
        </button>
      </div>
      <small class="error" *ngIf="password && !passwordValid">{{ 'add_user_dialog.password_min' | translate }}</small>
    </label>
    <label>
      <span>{{ 'add_user_dialog.confirm_password' | translate }}</span>
      <div class="password-group">
        <input [type]="showConfirmPassword ? 'text' : 'password'" [(ngModel)]="confirmPassword" />
        <button class="icon-btn" type="button" (click)="showConfirmPassword = !showConfirmPassword">
          <span class="material-symbols-outlined">{{ showConfirmPassword ? 'visibility_off' : 'visibility' }}</span>
        </button>
      </div>
      <small class="error" *ngIf="confirmPassword && !passwordsMatch">{{ 'add_user_dialog.passwords_no_match' | translate }}</small>
    </label>
  </div>
  <div class="modal-footer">
    <button class="button secondary" type="button" (click)="onCancel()" [disabled]="submitting">{{ 'add_user_dialog.cancel' | translate }}</button>
    <button class="button" type="button" (click)="onSubmit()" [disabled]="!formValid || submitting">{{ 'add_user_dialog.submit' | translate }}</button>
  </div>
</div>


